var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.05,
    height: 13.454,
    viewBox: "0 0 17.05 13.454",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail-inbox-app",
    d: "M13.054,67.454H4a4,4,0,0,1-4-4V58a4,4,0,0,1,4-4h9.058a4,4,0,0,1,4,4v5.461A4,4,0,0,1,13.054,67.454ZM4,55.332A2.667,2.667,0,0,0,1.332,58v5.461A2.667,2.667,0,0,0,4,66.122h9.058a2.667,2.667,0,0,0,2.664-2.664V58a2.667,2.667,0,0,0-2.664-2.664Zm6.969,6.574,3.292-2.515a.666.666,0,1,0-.809-1.059l-3.292,2.514a2.671,2.671,0,0,1-3.229,0l-3.19-2.479a.666.666,0,0,0-.818,1.052L6.113,61.9l0,0a4.006,4.006,0,0,0,4.847,0Z",
    transform: "translate(0 -54)",
    fill: "#ff5e15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailicon);
export default __webpack_public_path__ + "static/media/mailicon.24240c8f3e5d0be16432da16498ec32d.svg";
export { ForwardRef as ReactComponent };